/* unplugin-vue-components disabled */import script from "./PsNavTop.vue?vue&type=script&setup=true&lang=js"
export * from "./PsNavTop.vue?vue&type=script&setup=true&lang=js"

import "./PsNavTop.vue?vue&type=style&index=0&id=5f2d8c78&lang=scss"
import "./PsNavTop.vue?vue&type=style&index=1&id=5f2d8c78&scoped=true&lang=scss"

import exportComponent from "E:\\work\\品尚官网\\pszx-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f2d8c78"]])

export default __exports__